export async function createTotalWorkoutsView(gymStateDb: any, logger: any) {
  logger.info('create total-workouts view index');

  const ddoc = {
    _id: '_design/total-workouts-stats',
    views: {
      'total-workouts': {
        map: `function (doc) {\r\n
                if (doc.userProfileId && doc.checkedIn) {\r\n
                  emit(['TotalStartedWorkouts', doc.userProfileId, doc.gymName], 1);\r\n
                }\r\n
                if (doc.userProfileId && doc.checkedIn && !doc.removedAt) {\r\n
                    var date = new Date(doc.startTime);\r\n
                    if(doc.timezoneOffset) { date = new Date(date.getTime() + doc.timezoneOffset * 3600000)};\r\n
                    var key = [doc.userProfileId, date.getUTCFullYear(), (date.getUTCMonth() + 1)];\r\n
                    emit(key.concat([doc.settings.cardioOrResistance]), 1);\r\n
                    for (var idx in doc.settings.threeBodyGroups) {\r\n
                    emit(key.concat([doc.settings.threeBodyGroups[idx]]), 1);\r\n
                }\r\n
                    emit(key.concat(["Total"]), 1);\r\n
                    if(doc.performanceMetrics && doc.startTimeOfFirstExercise && doc.endTime){\r\n
                      var start = new Date(doc.startTimeOfFirstExercise);\r\n
                      var end = new Date(doc.endTime);\r\n
                      var diffMs = (end - start);\r\n
                      var totalMinutes = ((diffMs % 86400000) % 3600000) / 60000;\r\n
                      emit(key.concat(["totalMinutes"]), totalMinutes);\r\n
                    }\r\n
                    if (doc.performanceMetrics && doc.performanceMetrics.load){\r\n
                      emit(key.concat(["avWorkoutEffort"]), doc.performanceMetrics.load);\r\n
                    }\r\n
                    if (doc.performanceMetrics && doc.performanceMetrics.calories){\r\n
                      emit(key.concat(["Calories"]), doc.performanceMetrics.calories);\r\n
                    }\r\n
                }\r\n
            }`,
        reduce: '_sum',
      },
    },
  };

  await gymStateDb.put(ddoc);
}
